module.exports = __webpack_public_path__ + "img/marker.cfe2520f.png";